export const formatPrice = amount => {
	const units = Math.floor(amount)
	const hundreds = Math.round((amount - units) * 100)

	let afterComma = ''
	if (hundreds > 0) afterComma = `0${hundreds}`
	if (hundreds > 9) afterComma = `${hundreds}`

	return `€\xA0${units}${afterComma ? ',' + afterComma : ''}`
}

export function calculatePrice(obj: {
	has_payment?: boolean
	discount_price?: number | string
	price?: number | string
}): number {
	const {has_payment = false, discount_price = null, price = 0} = obj

	if (!has_payment) return 0
	if (discount_price !== null && discount_price !== '')
		return parseInt(discount_price as any, 10)

	return parseInt(price as any, 10)
}
